// ConsultantShareMonthly.styles.js — 상담자배분 창 [월별 실적] 탭 스타일 (2026-10-05)
//   창 본체 스타일(ConsultantShareLedgerModal.styles.js, 190줄)과 같은 토큰(var(--…))을 쓴다.
import { stdTabGroup, stdTabBtn } from '../adminlayout/designStandard';

const CURRENT_BG = 'var(--std-pill-on-bg, rgba(59,154,242,0.10))';

export const M = {
  tabs: { ...stdTabGroup, alignSelf: 'flex-start' },
  tabBtn: (active) => stdTabBtn(active),
  yearBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' },
  yearNav: { display: 'flex', alignItems: 'center', gap: 6 },
  yearBtn: (disabled) => ({
    width: 40, height: 40, border: '1px solid var(--border)', borderRadius: 10, background: 'var(--bg-card)',
    color: disabled ? 'var(--text-muted)' : 'var(--text)', cursor: disabled ? 'default' : 'pointer',
    opacity: disabled ? 0.45 : 1, fontWeight: 900,
  }),
  yearLabel: { minWidth: 72, textAlign: 'center', fontSize: 15, fontWeight: 950, color: 'var(--text)' },
  note: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6 },
  section: { display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 },
  sectionHead: { display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' },
  sectionTitle: { fontSize: 14, fontWeight: 950, color: 'var(--text)' },
  sectionHint: { fontSize: 11, color: 'var(--text-muted)', fontWeight: 700 },
  empty: {
    border: '1px dashed var(--border)', borderRadius: 10, padding: 14, textAlign: 'center',
    fontSize: 12, color: 'var(--text-muted)',
  },
  tableBox: { overflowX: 'auto', border: '1px solid var(--border)', borderRadius: 10, minWidth: 0 },
  table: { width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: 12 },
  thName: {
    position: 'sticky', left: 0, zIndex: 2, background: 'var(--bg-subtle)', textAlign: 'left',
    padding: '8px 10px', fontWeight: 900, color: 'var(--text-sub)', borderBottom: '1px solid var(--border)',
    minWidth: 96, whiteSpace: 'nowrap',
  },
  th: (current) => ({
    background: current ? CURRENT_BG : 'var(--bg-subtle)', padding: '8px 6px', textAlign: 'center', fontWeight: 900,
    color: current ? 'var(--text)' : 'var(--text-sub)', borderBottom: '1px solid var(--border)', minWidth: 84, whiteSpace: 'nowrap',
  }),
  thTotal: {
    background: 'var(--bg-subtle)', padding: '8px 8px', textAlign: 'center', fontWeight: 950, color: 'var(--text)',
    borderBottom: '1px solid var(--border)', borderLeft: '1px solid var(--border)', minWidth: 96, whiteSpace: 'nowrap',
  },
  nameCell: (isTotal) => ({
    position: 'sticky', left: 0, zIndex: 1, background: isTotal ? 'var(--bg-subtle)' : 'var(--bg-card)',
    padding: '7px 10px', fontWeight: isTotal ? 950 : 800, color: 'var(--text)', whiteSpace: 'nowrap',
    borderTop: isTotal ? '1px solid var(--border)' : 'none',
  }),
  retired: {
    marginLeft: 5, padding: '1px 5px', borderRadius: 999, fontSize: 10, fontWeight: 800,
    color: 'var(--text-muted)', border: '1px solid var(--border)',
  },
  td: (current, isTotal) => ({
    background: current ? CURRENT_BG : (isTotal ? 'var(--bg-subtle)' : 'transparent'),
    padding: '6px 6px', textAlign: 'center', verticalAlign: 'middle', whiteSpace: 'nowrap',
    borderTop: isTotal ? '1px solid var(--border)' : 'none',
  }),
  tdTotal: (isTotal) => ({
    background: 'var(--bg-subtle)', padding: '6px 8px', textAlign: 'center', whiteSpace: 'nowrap',
    borderLeft: '1px solid var(--border)', borderTop: isTotal ? '1px solid var(--border)' : 'none',
  }),
  cellCount: (negative) => ({ fontSize: 12, fontWeight: 900, color: negative ? '#dc2626' : 'var(--text)', fontVariantNumeric: 'tabular-nums' }),
  cellQty: (negative) => ({ fontSize: 11, color: negative ? '#dc2626' : 'var(--text-muted)', fontVariantNumeric: 'tabular-nums' }),
  cellAmount: (negative) => ({ fontSize: 11, fontWeight: 800, color: negative ? '#dc2626' : 'var(--text-sub)', fontVariantNumeric: 'tabular-nums' }),
  cellZero: { fontSize: 12, color: 'var(--text-muted)' },
};
